'use client';

import { MoonIcon, SunIcon } from '@heroicons/react/20/solid';
import type { FC } from 'react';
import withThemeToggle from '@/components/hoc/withThemeToggle';
import { track } from '@/lib/analytics/events';
import type { TWithThemeToggle } from '@/lib/interfaces/hoc/withThemeToggle.types';
import type { TThemeToggle } from '@/lib/interfaces/units/themeToggle.types';
import cn from '@/lib/packages/cn';
import Toggle from '@/ui/Toggle';

const ThemeToggle: FC<TThemeToggle & TWithThemeToggle> = ({
  className,
  size = 'md',
  variant = 'primary',
  isDark,
  toggleTheme,
}) => {
  const handleChange = () => {
    const prev = isDark ? 'dark' : 'light';
    const next = isDark ? 'light' : 'dark';
    track.theme({ previous_theme: prev, next_theme: next });
    toggleTheme();
  };

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Toggle
        size={size}
        checked={isDark}
        variant={variant}
        onChange={handleChange}
        aria-label='Toggle theme mode'
        data-skip-autoclick='1'
        uncheckedIcon={<SunIcon className='h-4 w-4 text-secondary' />}
        checkedIcon={<MoonIcon className='h-4 w-4 text-primary' />}
      />
    </div>
  );
};

ThemeToggle.displayName = 'ThemeToggle';

export default withThemeToggle(ThemeToggle);
